import React from "react";
import { Modal, Button } from "react-bootstrap";
import "../../assets/styles/WhatsNewModal.css";

const APP_VERSION = "0.1.3"; // Update this when making significant changes

{
  /* <div className="version-info">
          <div className="feature-tag feature-tag-beta">vX.X.X</div>
          <p className="release-date">
            MONTH DAY, YEAR • Serial Number Fixes and Improvements
          </p>
        </div>
        <h3 className="whats-new-title">What's New in This Update</h3>
        <div className="mb-4">
          <div className="update-section">
            <span className="feature-tag feature-tag-new">NEW FEATURES</span>
          </div>
          <div className="update-section">
            <span className="feature-tag feature-tag-improvements">
              IMPROVEMENTS
            </span>
          </div>
          <div className="update-section">
            <span className="feature-tag feature-tag-fixes">
              COMPONENT UPDATES
            </span>
          </div>
          <div className="update-section">
            <span className="feature-tag feature-tag-bug-fixes">BUG FIXES</span>
          </div>
        </div>

        <h3>Coming Soon</h3>
        <div>
          <div className="update-section">
            <span className="feature-tag feature-tag-planned">
              PLANNED FEATURES
            </span>
            <ul>
              <li>
                Ability to Edit "General Tower Description" in the Opportunity
                window.
              </li>
              <li>Ability to create a "Blank/Custom" Scope of Work</li>
              <li>UX/UI Improvements for navigating</li>
              <li>
                "Create a Tower" page visual improvement, sections, and question
                grouping
              </li>
              <li>Better Components Validation before Submitting</li>
              <li>User preference settings (Sales Team, Management, Etc)</li>
              <li>
                More consistency amongst components (ex: Transverse/Trans, Unit
                Values, Placeholders, etc)
              </li>
            </ul>
          </div>

          <div className="update-section">
            <span className="feature-tag feature-tag-upcoming">
              SCOPES TO COMPLETE
            </span>
            <ul>
              <li>Counterflow DE, Counterflow Dist System, Structure</li>
            </ul>
          </div>
        </div>

        <hr className="mb-4"></hr> */
}
const WhatsNewModal = ({ show, onHide }) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      aria-labelledby="whats-new-modal"
      centered
      className="release-notes-modal"
      dialogClassName="modal-90w"
    >
      <div className="release-header">
        <div style={{ display: "flex", alignItems: "center" }}>
          <h1 className="release-title">Latest Updates</h1>
          <span className="release-version">
            from Scope of Work App v{APP_VERSION}
          </span>
        </div>
        <button
          type="button"
          className="btn-close btn-close-white header-close-btn"
          onClick={onHide}
          aria-label="Close"
        ></button>
      </div>

      <Modal.Body className="modal-scrollable-body">
        <div className="beta-notice">
          <h5 className="beta-notice-title">Beta Application Notice</h5>
          <p className="beta-notice-text">
            This application is currently in <strong>BETA</strong>. Some
            features may not work as intended, and there is a risk that entered
            information could be lost. Please report any issues you encounter to
            the development team.
          </p>
        </div>{" "}
        <div className="version-info">
          <div className="feature-tag feature-tag-beta">v0.1.3</div>
          <p className="release-date">
            June 11, 2025 • Rob Feedback Changes #2
          </p>
        </div>
        <h3 className="whats-new-title">What's New in This Update</h3>
        <div className="mb-4">
          <div className="update-section">
            <span className="feature-tag feature-tag-new">NEW FEATURES</span>{" "}
            <ul>
              <li>
                <strong>Added: </strong>Firewalls and Partition Walls have been
                added to the Create Tower Page and to the Opportunity Modal.
              </li>
              <li>
                <strong>Added: </strong>Louver Material has been added to the
                Opportunity Modal.
              </li>
            </ul>
          </div>
          <div className="update-section">
            <span className="feature-tag feature-tag-improvements">
              IMPROVEMENTS
            </span>
            <ul>
              <li>
                <strong>Added: </strong>The ability to add "/" to some number
                values. <i>(Example: "5 1/2")</i> If I missed some, let me know.
              </li>
              <li>
                The question "Louvers?" will always be "Yes" if the tower type
                is "Crossflow"
              </li>
            </ul>
          </div>
          <div className="update-section">
            <span className="feature-tag feature-tag-fixes">
              COMPONENT UPDATES
            </span>
            <div className="component-fixes">
              <div className="update-section">
                <p className="component-name">Casing</p>
                <ul className="component-changes">
                  <li>
                    <strong>Added: </strong>"Other" option to "Furring Strips"
                  </li>
                  <li>
                    <strong>Added:</strong> "Does Casing contain Asbestos?"
                    question
                  </li>
                </ul>
              </div>{" "}
              <div className="update-section">
                <p className="component-name">Drift Eliminators</p>
                <ul className="component-changes">
                  <li>
                    "Support Material (at Bent Line)" question - If "None,
                    Supported By Laterals" is selected, no other questions will
                    show up
                  </li>
                </ul>
              </div>
              <div className="update-section">
                <p className="component-name">Crossflow Fill</p>
                <ul className="component-changes">
                  <li>
                    <strong>Updated: </strong>"Wire Grid Hanger Nominal Spacing"
                    options now show different choices based on orientation:
                    <ul>
                      <li>
                        <strong>Parallel: </strong>24", 30", 36", 48" and Other
                      </li>
                      <li>
                        <strong>Perpendicular: </strong>2 Wires Per Longl Bay, 3
                        Wires Per Longl Bay, 4 Wires Per Longl Bay
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
              <div className="update-section">
                <p className="component-name">Cold Water Basin</p>
                <ul className="component-changes">
                  <li>
                    <strong>Reworded:</strong> "Does CWB have perimeter piers?"
                    ⇒ "Are there Piers or a Shelf?"
                  </li>
                  <li>
                    <strong>Moved: </strong>"Individual Pier Size", "Top of Curb
                    to Top of Pier", "Shelf Width", "Top of Curb to Top of
                    Shelf" to their respective nested areas in "Are there Piers
                    or a Shelf?"
                  </li>
                </ul>
              </div>
              <div className="update-section">
                <p className="component-name">Fandeck</p>
                <ul className="component-changes">
                  <li>
                    <strong>Adjusted: </strong>Crossflow Question "Cell Width" ⇒
                    "<strong>Fandeck </strong>Width (ft/in)"
                  </li>

                  <li>
                    <strong>Added: </strong>"ft/in" unit to "Width of Extension"
                    question
                  </li>

                  <li>
                    <strong>Added: </strong>"ft" unit to "Length of Extension"
                    question
                  </li>
                </ul>
              </div>
              <div className="update-section">
                <p className="component-name">General Tower Description</p>
                <ul className="component-changes">
                  <li>
                    <strong>Added: </strong>"Fill Height" and "Louver Height" to
                    Crossflow "Air Inlet Height" question.
                  </li>
                </ul>
              </div>
            </div>
          </div>{" "}
          <div className="update-section">
            <span className="feature-tag feature-tag-bug-fixes">BUG FIXES</span>
            <ul>
              <li>
                "Top Shelf Material" was not showing up in Drift Eliminators
              </li>
              <li>
                Removed the ability to put decimals in certain fields (if I miss
                any, let me know)
              </li>
              <li>Fixed bug where Louver Material wasn't saving properly</li>
              <li>
                Fixed issue preventing tower from being saved if casing material
                wasn't filled in
              </li>
            </ul>
          </div>
        </div>
        <h3>Coming Soon</h3>
        <div>
          <div className="update-section">
            <span className="feature-tag feature-tag-planned">
              PLANNED FEATURES
            </span>
            <ul>
              <li>
                Ability to Edit "General Tower Description" in the Opportunity
                window.
              </li>
              <li>Ability to create a "Blank/Custom" Scope of Work</li>
              <li>UX/UI Improvements for navigating</li>
              <li>
                "Create a Tower" page visual improvement, sections, and question
                grouping
              </li>
              <li>Better Components Validation before Submitting</li>
              <li>User preference settings (Sales Team, Management, Etc)</li>
              <li>
                More consistency amongst components (ex: Transverse/Trans, Unit
                Values, Placeholders, etc)
              </li>
            </ul>
          </div>

          <div className="update-section">
            <span className="feature-tag feature-tag-upcoming">
              SCOPES TO COMPLETE
            </span>
            <ul>
              <li>Counterflow DE, Counterflow Dist System, Structure</li>
            </ul>
          </div>
        </div>
        <hr className="mb-4"></hr>
        <h3>Previous Updates (v0.1.2)</h3>
        <div className="version-info">
          <div className="feature-tag feature-tag-beta">v0.1.2</div>
          <p className="release-date">June 10, 2025 • Serial Number Hotfix</p>
        </div>
        <p className="update-description">
          Wanted to push out this fix as soon as possible as to not hinder the
          creation of new serial numbers.
        </p>
        <div className="mb-4">
          <div className="update-section">
            <ul>
              <li>
                Fixed an issue where the serial number was not being generated
                correctly when creating a new tower.
              </li>
              <li>
                As Mary pointed out there are already serial numbers in the
                system starting at XX-XXX-0000000 and going to XX-XX-0000118, so
                the next serial number that is created will be XX-XXX-0000119,
                and it will increment by 1 for each new number generated.
              </li>
            </ul>
          </div>
        </div>
        <hr className="mb-4"></hr>
        <div className="version-info">
          <div className="feature-tag feature-tag-beta">v0.1.1</div>
          <p className="release-date">
            June 6, 2025 • Minor Fixes and Improvements
          </p>
        </div>
        <div className="mb-4">
          <div className="update-section">
            <span className="feature-tag feature-tag-fixes">
              COMPONENT UPDATES
            </span>

            <div className="component-fixes">
              <div className="update-section">
                <p className="component-name">M&G Support</p>
                <ul className="component-changes">
                  <li>
                    "Under Motor Length" unit value is now "
                    <strong>feet</strong>"
                  </li>
                  <li>
                    <strong>Added: </strong>Placeholder text for "Structural
                    Size":
                    <strong> "eg., W6x15"</strong>
                  </li>
                  <li>
                    "Structural Shape" changed from "text" a Drop Down list with
                    the values of "I-Beam, W-Beam, Channel, Tube, Other"
                  </li>
                </ul>
              </div>
              <div className="update-section">
                <p className="component-name">Plenum Access Ladder</p>
                <ul className="component-changes">
                  <li>
                    <strong>Added: </strong>Placeholder text for "Ladder
                    Length": <strong>"Approximate"</strong>
                  </li>
                  <li>
                    "Ladder Orientation" ⇒ <strong>"Ladder Position"</strong>
                  </li>
                  <li>
                    "Ladder Orientation/<strong>Position</strong> options
                    "Trans" and "Longl" ⇒{" "}
                    <strong>"Installed on Trans Bent"</strong> and{" "}
                    <strong>"Installed on Longl Bent</strong>
                  </li>
                </ul>
              </div>
              <div className="update-section">
                <p className="component-name">Motor</p>
                <ul className="component-changes">
                  <li>
                    "Speed" dropdown options have been changed for "Two" from
                    900/1800 ⇒ <strong>"Single Winding"</strong> and{" "}
                    <strong>"Double Winding"</strong>
                  </li>
                </ul>
              </div>

              <div className="update-section">
                <p className="component-name">Stairway</p>
                <ul className="component-changes">
                  <li>
                    <strong>Added: </strong> Placeholder text for "Height" and
                    "Distance from Post": <strong>"Approximate"</strong>
                  </li>
                </ul>
              </div>

              <div className="update-section">
                <p className="component-name">Louvers</p>
                <ul className="component-changes">
                  <li>
                    In "Components" tab, If "Louvers?" is set to "No", the rest
                    of the questions will not show up.
                  </li>
                </ul>
              </div>
              <div className="update-section">
                <p className="component-name">Tower Manufacturer</p>
                <ul className="component-changes">
                  <li>
                    <strong>Typo: </strong>Thermodynamics ⇒{" "}
                    <strong>Thermaldynamics</strong>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <hr className="mb-4"></hr>
        <div className="version-info">
          <div className="feature-tag feature-tag-beta">BETA</div>
          <p className="release-date">
            June 5, 2025 • Application Status Update
          </p>
        </div>
        <div className="mb-4">
          <div className="update-section">
            <span className="feature-tag feature-tag-new">NEW FEATURES</span>
            <ul>
              <li>
                "Latest Updates" modal to keep you informed of updates that are
                pushed to the application.
                <i> This will only display once per version.</i> To view update
                notes again, click the button in the bottom right of the screen.
              </li>
              <li>
                When deleting a tower you are now required to confirm twice
                before deletion.
              </li>
            </ul>
          </div>

          <div className="update-section">
            <span className="feature-tag feature-tag-improvements">
              IMPROVEMENTS
            </span>
            <ul>
              <li>
                "Action" buttons on the Opportunities Dashboard changed to their
                names, instead of icons.{" "}
                <i>(Ex: "Edit Tower", "Create Tower")</i>
              </li>
              <li>
                Decimals Added to Number Fields, with up to two decimal places
              </li>
              <li>
                Commas have been added when entered numbers over 999 for GPM
              </li>
              <li>
                Tooltips have been added when hovering the "Actions" buttons in
                the towers tab for better understanding of their purpose
              </li>
              <li>
                "Create New Serial Number" modal has been updated with better
                text explaining what is happening
              </li>
              <li>Default Font Family changed from "Inter" ⇒ "Arial" </li>
            </ul>
          </div>

          <div className="update-section">
            <span className="feature-tag feature-tag-fixes">
              COMPONENT UPDATES
            </span>

            <div className="component-fixes">
              <div className="update-section">
                <p className="component-name">Cold Water Basin</p>
                <ul className="component-changes">
                  <li>
                    <strong>Added:</strong> "(Approximate)" placeholder text to
                    "Grade to Curb Height"
                  </li>
                  <li>
                    <strong>Added:</strong> "Feet" unit value to "Grade to Curb
                    Height"
                  </li>
                </ul>
              </div>
              <div className="update-section">
                <p className="component-name">Tower Manufacturer</p>
                <ul className="component-changes">
                  <li>
                    <strong>Added:</strong> "Thermodynamics" to the list of
                    manufacturers
                  </li>
                </ul>
              </div>
              <div className="update-section">
                <p className="component-name">Dist System</p>
                <ul className="component-changes">
                  <li>
                    "Header Diameter" ⇒ "Header Diameter{" "}
                    <strong>(at Riser)</strong>"
                  </li>
                </ul>
              </div>
              <div className="update-section">
                <p className="component-name">M&G Support</p>
                <ul className="component-changes">
                  <li>
                    "Torque Tube Diameter" unit value is now "
                    <strong>inches</strong>"
                  </li>
                  <li>
                    "Torque Tube Length" ⇒ "Torque Tube Length{" "}
                    <strong>(approximate)</strong>"
                  </li>
                </ul>
              </div>
              <div className="update-section">
                <p className="component-name">Cell Height</p>
                <ul className="component-changes">
                  <li>
                    <strong>Added:</strong> "Top of Basin Curb to Fandeck"
                    Placeholder
                  </li>
                </ul>
              </div>
              <div className="update-section">
                <p className="component-name">Drive Shaft</p>
                <ul className="component-changes">
                  <li>
                    <strong>Spelling:</strong> "Adday / Rexnord" ⇒ "
                    <strong>Addax</strong> / Rexnord"
                  </li>
                </ul>
              </div>
              <div className="update-section">
                <p className="component-name">Fire Wall</p>
                <ul className="component-changes">
                  <li>
                    <strong>Wording: </strong>"Is there a fire wall?" ⇒ "
                    <strong>Are there Fire Walls?</strong>"
                  </li>
                </ul>
              </div>
              <div className="update-section">
                <p className="component-name">Wind Wall</p>
                <ul className="component-changes">
                  <li>
                    <strong>Wording: </strong>"Is there a wind wall?" ⇒ "
                    <strong>Are there Wind Walls?</strong>"
                  </li>
                </ul>
              </div>
              <div className="update-section">
                <p className="component-name">General Tower Description</p>
                <ul className="component-changes">
                  <li>
                    <strong>Added: </strong> "Fill Orientation to Airflow"
                    question to "What is the Crossflow Fill Type?"
                  </li>
                  <li>
                    <strong>Added: </strong> Partition Wall Questions, and Fire
                    Wall Questions
                  </li>
                </ul>
              </div>{" "}
              <div className="update-section">
                <p className="component-name">Opportunity Modal</p>
                <ul className="component-changes">
                  <li>
                    <strong>Added: </strong> "Fill Orientation to Airflow"
                    question to "What is the Crossflow Fill Type?"
                  </li>
                  <li>
                    <strong>Added: </strong> Partition Wall Questions, and Fire
                    Wall Questions
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="update-section">
            <span className="feature-tag feature-tag-scopes">SCOPES ADDED</span>
            <ul>
              <li>
                Fan, Gear, Drive Shaft, Motor, M&G Supports, Mechanical Access,
                Fanstack, Fandeck, Counterflow Fill, Partition Wall, Fire Wall,
                Ladder, Stairway, Windwall.
              </li>
            </ul>
          </div>

          <div className="update-section">
            <span className="feature-tag feature-tag-bug-fixes">BUG FIXES</span>
            <ul>
              <li>
                "Casing Material" was showing up twice in the Opportunity Modal.
              </li>
            </ul>
          </div>
        </div>
      </Modal.Body>

      <Modal.Footer className="modal-sticky-footer">
        <div className="footer-text">Powered by Amertech Tower Services</div>
        <Button variant="primary" onClick={onHide} className="close-button">
          Got it!
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default WhatsNewModal;
